/**
 * @typedef {import('./components/BaseComponent').default} BaseComponent
 */

import RefreshableComponent from './components/RefreshableComponent';
import mediator from './services/shared/mediator';

class Main {
  constructor(moduleFactory) {
    /** @type {Record<string, BaseComponent>} */
    this.runningModules = {};

    this.instantiateModules = ({ selector = 'body', refresh = false }) => {
      const root = document.querySelector(selector);

      root.querySelectorAll('[data-module]').forEach(async (el) => {
        const { module, ...props } = el.dataset;
        const component = await moduleFactory(module);

        // only run refreshable modules when refresh is true
        if (component && (!refresh || component.refreshable)) {
          if (props.init !== false) {
            const instance = new component(props, el);
            instance.init();
            this.runningModules[module] = instance;
          }
        }
      });
    };

    mediator.subscribe('components:refresh', this, this.refresh);
  }

  init() {
    this.instantiateModules({});
  }

  refresh() {
    // clean up existing, refreshable modules
    Object.values(this.runningModules)
      .filter(module => module instanceof RefreshableComponent)
      .forEach(module => module.destroy());
    // re-instantiate all refreshable modules
    this.instantiateModules({ refresh: true });
  }
}

export default Main;
